import styled, {css} from 'styled-components'
import {ButtonNavLink} from '@/components/ui/button-nav-link/ButtonNavLink'

export const StyledTabs = styled.div<{$paddingX?: number}>(
    ({theme: {palette, spacing}, $paddingX = 0}) => css`
        padding: ${$paddingX ? `0 ${spacing * $paddingX}px` : 0};
        border-bottom: 1px solid ${palette.neutral[200]};
        display: flex;
    `
)

export const StyledTab = styled(ButtonNavLink)(
    ({theme: {palette, typography}}) => css`
        height: 100%;
        color: ${palette.neutral['500']};
        ${typography.textMd};
        border-radius: 0;
        border-bottom-width: 2px;
        border-bottom-style: solid;
        border-bottom-color: transparent;
        & svg {
            width: 18px;
            height: 18px;
        }

        &.active {
            color: ${palette.primary['500']};
            border-bottom-color: ${palette.primary['500']};
            & span {
                visibility: visible;
            }
        }
    `
)

export const StyledTabWarning = styled.span(
    ({theme: {palette}}) => css`
        visibility: hidden;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: ${palette.orange['600']};
    `
)
